import styled from "styled-components";

import { colors, globalStyle } from "global/globalStyle";

export const Container = styled.div<any>`
  .MuiTab-root {
    font-family: ${globalStyle.fontFamily};
    font-weight: 700;
    font-size: 12px;
    background-color: ${colors};
    color: ${colors.default_base_black};
    border-radius: 50px;
    margin: 1px;
    min-width: auto;

    min-height: 35px;
    max-height: 45px;
    margin-right: 4px;
    margin-top: 6px;
    margin-bottom: 6px;

    align-items: center;
    align-self: center;
    align-content: center;
  }

  .MuiTab-root.Mui-selected {
    border: 10px;
    background-color: ${colors.default_base_orange};
    color: ${colors.default_hover_light_grey};
  }

  .MuiTab-root:not(.Mui-selected):hover {
    border: 10px;
    background-color: ${colors.default_hover_light_grey};
  }
`;
